const styles = {
  headerRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '28px', sm: '38px' },
    lineHeight: '100%',
    color: '#5236AB',
  },
};

export default styles;
